import styled from 'styled-components';

export const KeywordContainer = styled.div`
  display: flex;
  padding: 5px 10px;
  margin: 10px 0px;
  width: 100%;
  background-color: #f3f3f3;
  border-radius: 10px;
  flex-direction: column;
`;

export const KeywordRow = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export interface KeywordTextProps {
  bold?: boolean;
  danger?: boolean;
}

export const KeywordText = styled.div<KeywordTextProps>`
  margin: 0px 5px;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  color: ${(props) => (props.danger ? '#ff0000' : '#000')};
`;
